module.exports = __webpack_public_path__ + "static/media/add-guide lines.51a83edb.svg";